import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/siteData";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Beautiful%20fashion%20boutique%20display%20with%20neatly%20arranged%20sneakers%20hoodies%20and%20accessories%20on%20warm%20wooden%20shelves%2C%20cream%20colored%20walls%2C%20large%20windows%20with%20soft%20natural%20morning%20light%20streaming%20in%2C%20potted%20plants%20and%20minimalist%20decor%2C%20modern%20Scandinavian%20retail%20interior%2C%20clean%20aesthetic%2C%20sage%20green%20and%20warm%20beige%20color%20accents%2C%20high%20end%20editorial%20product%20photography%2C%20inviting%20and%20serene%20shopping%20atmosphere&width=1800&height=900&seq=hero-bg-v3&orientation=landscape&nocache=true')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-background-50/60"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-full mb-6">
              <div className="w-2 h-2 rounded-full bg-primary-500"></div>
              <span className="text-xs font-medium text-foreground-800">Updated August 2026</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 drop-shadow-lg">
              BaseTao Spreadsheet:<br />
              <span className="text-primary-300">The Complete Research Guide</span> For Smarter Shopping
            </h1>
            <p className="text-base md:text-lg text-background-100/90 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0 drop-shadow-md">
              Everything you need to understand BaseTao Spreadsheet, compare products, estimate shipping costs, find warehouse information, and make better purchasing decisions.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/article/basetao-spreadsheet-guide"
                className="w-full sm:w-auto px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                Explore BaseTao Spreadsheet Guide
              </Link>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-6 py-3 bg-background-50/90 backdrop-blur-sm text-foreground-900 font-semibold text-sm rounded-md hover:bg-background-50 transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                Visit BaseTao Store
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 justify-center lg:justify-start mt-8">
              {[
                { icon: "ri-check-line", text: "Updated Research" },
                { icon: "ri-check-line", text: "Independent Guides" },
                { icon: "ri-check-line", text: "Shipping Analysis" },
                { icon: "ri-check-line", text: "Comparison Tools" },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-primary-400 text-sm`}></i>
                  </div>
                  <span className="text-xs text-background-100/90">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 hidden lg:flex justify-center">
            <div className="relative w-[420px] h-[380px] bg-background-50/10 backdrop-blur-sm rounded-2xl border border-background-100/20 overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=Fashion%20product%20catalog%20grid%20with%20beautiful%20clothing%20shoes%20and%20accessories%20displayed%20in%20an%20organized%20layout%2C%20modern%20clean%20UI%20design%2C%20soft%20warm%20lighting%2C%20cream%20white%20and%20sage%20green%20color%20palette%2C%20minimalist%20aesthetic%2C%20professional%20product%20display%2C%20high%20detail%2C%20elegant%20commercial%20photography%20style&width=840&height=760&seq=hero-dash-v3&orientation=landscape&nocache=true')`,
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}